export var downData = [
    {
        id: "1",
        numericalTitle: "0",
        title: "Cotizaciones",
    },
    {
        id: "2",
        numericalTitle: "0",
        title: "Pólizas Finalizadas",
    },
];
export var seriesFn = function (tl) {
    var series = [
        {
            color: "#3A56A1",
            data: [],
            name: tl("salesReport.barChart.series.name1"), //EMITIDAS
        },
        {
            color: "#A8B5D6",
            data: [],
            name: tl("salesReport.barChart.series.name2"), // COTIZADAS
        },
    ];
    return series;
};
export var categories = [];
export var dataChip = [
    {
        active: true,
        id: "1",
        name: "Mes actual",
        code: "currentMonth",
    },
    {
        active: false,
        id: "2",
        name: "Mes anterior",
        code: "prevMonth",
    },
    {
        active: false,
        id: "3",
        name: "Trimestre actual",
        code: "currentQuarter",
    },
    {
        active: false,
        id: "4",
        name: "Trimestre anterior",
        code: "prevQuarter",
    },
    {
        active: false,
        id: "5",
        name: "Semestre actual",
        code: "currentSemester",
    },
];
// {
//   "id": "quotePolices",
//   "name": "Cotizaciones / Ventas",
//   "icon": "icons.Shield",
//   "active": true,
//   "route": "/report-quote-sales/",
//   "divider": false
//
// },
